import { fetchAndStoreRoasters } from '$lib/dataLoader.js';
import { selectedLocation } from '$lib/PersistedState.svelte.js';

export async function load({ parent }) {
  await parent();
  fetchAndStoreRoasters(Number(selectedLocation.current));
  return {};
}
